import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from "rxjs/operators";

import { LCV_MOCK_COMPRA, LCV_MOCK_VENTA } from "../mocks/lcv-mock"
import { IListLibroCompraVentaReporteListarReportes, IResponseCalculos } from '../models/IResponseCalculos';
import { BackendAuthService } from 'src/app/shared/services/backend-auth.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { ICompra, IVenta } from '../models/IRegistros';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LcvApiService {

    private RutOrg = localStorage.getItem("selectedValue");

  constructor(
    private http: HttpClient,
    private _backendAuthService: BackendAuthService,
    private _sessionService: SessionService) { }


  validateCredentials(idUsuario: string , rut: string): Observable<any> {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("IDOrganization", `${rut}`);

    return this.http.get<any>(`${environment.backend.main}/SecretInteraction/buscarSecretosUsuario?idUsuario=${idUsuario}&idOrganizacion=${rut}&rut=${rut}&requestOrigin=STS`, { headers: headers }).pipe(
      map((res) => {
        return res
      })
    )
  }


  procesarPeriodo(rut: string, periodo: number | number[], idUsuario: string, idOrganizacion: string): Observable<IListLibroCompraVentaReporteListarReportes[]> {
    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);
    
    const payload: any = {
      rut: rut,
      periodo: periodo,
      idUsuario: idUsuario,
      idOrganizacion: idOrganizacion,
      requestOrigin: "WEB",
    }

    return this.http.post<IListLibroCompraVentaReporteListarReportes[]>(environment.backend.main + "/LibroCompraVenta" + "/crearReporte", payload,  { headers: headers }).pipe(
      map((res) => {
        return res;
      }));
  }

  obtenerTx(rut: string, periodo: number | number[], idUsuario: string, idOrganizacion: string): Observable<IListLibroCompraVentaReporteListarReportes[]> {
    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);
    
    let params = new HttpParams();
    params = params.append("rut", rut);
    params = params.append("idUsuario", idUsuario);
    params = params.append("idOrganizacion", idOrganizacion);
    params = params.append("requestOrigin", 'WEB');
    params = params.append("periodo", Array.isArray(periodo) ? periodo.toString() : periodo);

    return this.http.get<IListLibroCompraVentaReporteListarReportes[]>(environment.backend.main + "/LibroCompraVenta" + "/listarReportes", { params, headers: headers }).pipe(
      map((res) => {
        return res;
      }));
  }

  obtenerCalculos(idUsuario: string, rut: string, tipo: string, meses: string, periodo: any = null): Observable<IResponseCalculos> {
    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);
    
    let params = new HttpParams();
    params = params.append("rut", rut);
    params = params.append("idUsuario", idUsuario);
    params = params.append("idOrganizacion", rut);
    params = params.append("requestOrigin", 'WEB');
    params = params.append("meses", meses);
    params = params.append("operacion", tipo);

    if(periodo){
      params = params.append("periodo", periodo);
    }

    return this.http.get<IResponseCalculos>(environment.backend.main + "/LibroCompraVenta" + "/calcularRegistros", { params, headers: headers }).pipe(
      map((res) => {
        return res;
      }));
  }


  obtenerPagina(idUsuario: string, rut: string, pagina: number, cantidadElementos: number, tipo: string, meses: string, periodo: any = null): Observable<ICompra[] | IVenta[]> {
    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);
    
    let params = new HttpParams();
    params = params.append("rut", rut);
    params = params.append("idUsuario", idUsuario);
    params = params.append("idOrganizacion", rut);
    params = params.append("requestOrigin", 'WEB');
    params = params.append("meses", meses);
    params = params.append("operacion", tipo);
    params = params.append("pagina", pagina);
    params = params.append("registrosPagina", cantidadElementos);

    if(periodo){
      params = params.append("periodo", periodo);
    }

    return this.http.get<ICompra[] | IVenta[]>(environment.backend.main + "/LibroCompraVenta" + "/buscarRegistros", { params, headers: headers }).pipe(
      map((res) => {
        return res;
      }));
  }
}
